import { useState } from 'react';
import { useAppStateContext } from '@/contexts/app-state-context/useAppStateContext';
import { AlertNotificationCard } from '../alert-notification-card/alert-notification-card';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { NotificationCircle, CardContainer, PulsingDot } from './style-component';
import { useTheme } from '@/contexts/theme-context/useThemeContext';

const getNotificationType = (code: number) => {
    switch (code) {
        case 1000:
        return 'warning';
        case 2:
        return 'success';
        default:
        return 'error';
    }
};

export const AlertNotification = () => {
    const { appState } = useAppStateContext();
    const [showNotification, setShowNotification] = useState(true);
    const [showCard, setShowCard] = useState(false);
    const { theme } = useTheme();

    const handleCircleClick = () => {
        setShowCard(!showCard);
    };

    const handleDelete = () => {
        setShowNotification(false);
        setShowCard(false);
    };

    const handleHide = () => {
        setShowCard(false);
    };

    if (!showNotification) return null;

    const notificationType = getNotificationType(appState.code);

    if (appState.isHealthy) return null;
    
    return (
        <>
            <NotificationCircle data-testid="notification-circle" onClick={handleCircleClick}>
                <PulsingDot />
                <ExclamationCircleOutlined style={{ color: theme.colors.theme.warning, fontSize: '24px' }} />
            </NotificationCircle>
            <CardContainer data-testid="notification-card" $isVisible={showCard}>
                <AlertNotificationCard
                message={appState.message || 'Sistema en mantenimiento'}
                type={notificationType}
                duration={0}
                onDelete={handleDelete}
                onHide={handleHide}
            />
            </CardContainer>
        </>
    );
};
